// extracted by mini-css-extract-plugin
export default {"button":"css_button__uBEz5","text":"css_text__kF-6F","main":"css_main__97s5o","disabled":"css_disabled__AE9Ne","secondary":"css_secondary__Bux8e","inverse":"css_inverse__1fqtA"};